import type APIResponse from '../networks/api/APIResponse'

type FACADE_RESPONSE = {
  message: string | { message: string; data?: { RemainPinTryCnt: number } }
}
class NetworkFetchError extends Error {
  response: APIResponse
  data: FACADE_RESPONSE
  constructor(response: APIResponse, message: string) {
    const responseData: FACADE_RESPONSE = response.data as FACADE_RESPONSE

    if (typeof responseData?.message === 'string') {
      message = responseData.message
    } else if (typeof responseData?.message === 'object') {
      if (typeof responseData.message.message === 'string') {
        message = responseData.message.message
      }
    }

    super(message)

    this.response = response
    this.data = responseData
  }

  get reasonData() {
    return this.data
  }

  get isInvalidPIN() {
    return (
      typeof this.data.message === 'object' &&
      this.data.message.data?.RemainPinTryCnt !== undefined
    )
  }

  get remainPinTryCnt() {
    if (
      typeof this.data.message === 'object' &&
      this.data.message.data?.RemainPinTryCnt !== undefined
    ) {
      return this.data.message.data.RemainPinTryCnt
    }

    return undefined
  }

  get pinTryCnt() {
    if (typeof this.data.message === 'object' && this.data.message.data) {
      if (typeof this.data.message === 'object')
        return this.data.message.data.RemainPinTryCnt
    }

    return undefined
  }
}

export default NetworkFetchError
